import { render } from "./Slide.vue?vue&type=template&id=1deb8c40&scoped=true"
import script from "./Slide.vue?vue&type=script&lang=js"
export * from "./Slide.vue?vue&type=script&lang=js"

import "./Slide.vue?vue&type=style&index=0&id=1deb8c40&lang=scss&scoped=true"

import exportComponent from "/opt/homebrew/var/www/zsplus_channel/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1deb8c40"]])

export default __exports__